export const VIM_GUIDE = 'VIM_GUIDE';
export const DOMAIN_MEMBER = 'DOMAIN_MEMBER';
export const APPOINTMENT = 'APPOINTMENT';
export const SHARE = 'SHARE';
export const ACTIVATION = 'ACTIVATION';
export const INSTANT_BOOK = 'INSTANT_BOOK';
export const REQUEST_TO_BOOK = 'REQUEST_TO_BOOK';
export const CONCIERGE_BOOK = 'CONCIERGE_BOOK';
